// Breakpoints mapping screen width to item count
export const breakpoints = [
    { width: 1805, items: 3 },
    { width: 1366, items: 2 },
    { width: 1024, items: 2 },
    { width: 640, items: 2 },
    { width: 480, items: 2 },
    { width: 320, items: 1 },
];